
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M497 0H376.5c-8.284 0-15 6.716-15 15v105.5H256c-8.284 0-15 6.716-15 15V241H135.5c-8.284 0-15 6.716-15 15v105.5H15c-8.284 0-15 6.716-15 15V497c0 8.284 6.716 15 15 15h482c8.284 0 15-6.716 15-15V15c0-8.284-6.716-15-15-15zm-15 482H30v-90.5h105.5c8.284 0 15-6.716 15-15V271H256c8.284 0 15-6.716 15-15V150.5h105.5c8.284 0 15-6.716 15-15V30H482v452z"}})])
          )
        }
      }
    